<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('user.agent.members.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{ $t('user.title') }} > </span>
            <span class="back_loc">{{ $t('user.agent.members.title') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap type2">
          <v-data-table
            :headers="$getHeaderType1(headerTxt, headers)"
            :items="agentMembers"
            hide-default-footer
            class="new__type__table"
            disable-pagination
            :mobile-breakpoint="MobileBreakPoint"
            :class="fnGetItemRowClass"
            :item-class="fnGetItemRowClass"
            @click:row="fnDetail"
          >
            <template v-slot:item.email="{ item }">
              <span :class="{inactive: item.ind_active === 'N' ? true : false}">{{ item.email }}</span>
            </template>
            <template v-slot:item.name_en="{ item }">
              <span :class="{inactive: item.ind_active === 'N' ? true : false}">{{ item.name_en }}</span>
            </template>
            <template v-slot:item.name_ar="{ item }">
              <span :class="{inactive: item.ind_active === 'N' ? true : false}">{{ item.name_ar }}</span>
            </template>
            <template v-slot:item.ind_representative="{ item }">
              <span :class="{inactive: item.ind_active === 'N' ? true : false}">{{item.ind_representative == 'Y' ? 'O' : ''}}</span>
            </template>
            <template v-slot:item.agent_authorization_type_code="{ item }">
              <template v-if="item.agent_authorization_type_code == '2801'">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="#a01c2a" v-on="on" v-bind="attrs" :class="{inactive: item.ind_active === 'N' ? true : false}">mdi-lock-open-outline</v-icon>
                  </template>
                  <span class="ft-size12">{{ fnGetAgentAuthTypeDesc(item.agent_authorization_type_code) }}</span>
                </v-tooltip>
              </template>
              <template v-if="item.agent_authorization_type_code == '2802'">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="#a01c2a" v-on="on" v-bind="attrs" :class="{inactive: item.ind_active === 'N' ? true : false}">mdi-eye</v-icon>
                  </template>
                  <span class="ft-size12">{{ fnGetAgentAuthTypeDesc(item.agent_authorization_type_code) }}</span>
                </v-tooltip>
              </template>
              <template v-if="item.agent_authorization_type_code == '2803'">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="#a01c2a" v-on="on" v-bind="attrs" :class="{inactive: item.ind_active === 'N' ? true : false}">mdi-lock</v-icon>
                  </template>
                  <span class="ft-size12">{{ fnGetAgentAuthTypeDesc(item.agent_authorization_type_code) }}</span>
                </v-tooltip>
              </template>
            </template>
            <template v-slot:item.seq="{ item }">
              <v-btn class="cir_cle_btn_table" @click.stop="fnMemberDeleteConfirm(item)" v-if="item.ind_active === 'Y'">
                <v-icon color="#a01c2a">mdi-close-circle-outline</v-icon>
              </v-btn>
              <span v-if="item.ind_active === 'N'" class="inactive">{{ $t('common.button.inactive') }}</span>
            </template>
          </v-data-table>

          <v-layout>
              <v-spacer/>
              <v-btn
              color="#a01c2a"
              dark
              min-width="150"
              min-height="50"
              class="mt-20 btn-normal br_none" @click="agentMemberAdd = true">{{$t('common.button.add')}}</v-btn>
          </v-layout>
        </v-flex>

        <!-- 등록 -->
        <AgentMemberAdd
          :dialog.sync="agentMemberAdd"
          @success="fnGetAgentMembers()"
          @close="agentMemberAdd = false"
        />

        <!-- 상세보기 -->
        <AgentMemberDetail
          :dialog.sync="agentMemberDetail"
          :seq.sync="seq"
          :tab.sync="tab"
          @success="fnGetAgentMembers()"
          @close="fnCloseDetail"
        />

      </v-layout>
    </v-layout>
    <confirm-dialog :id="id" @delete="fnMemberDelete" />
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import ConfirmDialog from '@/components/layout/ConfirmDialog'
import AgentMemberAdd from './AgentMemberAdd'
import AgentMemberDetail from './AgentMemberDetail'

export default {
  name: 'AgentMembers',
  components :{
    AgentMemberAdd,
    AgentMemberDetail,
    ConfirmDialog
  },
  data () {
    return {
      MobileBreakPoint : 0,
      id: 'AgentMembers',
      headerTxt : {
        prefix : 'user.agent.members.fields.',
        txt : ['e_mail','english_name','arabic_name','representative','authorization','' ]
      },
      headers: [
        { text: 'e-mail',
          align: 'center',
          value: 'email',
          sortable: false
        },
        { text: 'English Name',
          align: 'center',
          value: 'name_en',
          sortable: false
        },
        { text: 'Arabic Name',
          align: 'center',
          value: 'name_ar',
          sortable: false
        },
        { text: 'Representative',
          align: 'center',
          value: 'ind_representative',
          sortable: false
        },
        { text: 'Authorization',
          align: 'center',
          value: 'agent_authorization_type_code',
          sortable: false
        },
        { text: '',
          align: 'center',
          value: 'seq',
          sortable: false
        }
      ],

      agentMembers : [],

      agentMemberAdd : false,
      agentMemberDetail : false,

      seq: null,
      tab: '',
      agentAuthorizationTypeArList: [],
      agentAuthorizationTypeEnList: [],
    }
  },
  mounted(){
    window.scrollTo(0, 0)
    this.fnInit()
  },
  methods: {
    fnInit() {
      let seq = this.$route.query.seq
      if (seq) {
        this.tab = 'tab-2'
        this.fnDetail({seq: parseInt(seq, 10)})
      }


      let options = {
        upper_code: '2800'
      }
      utils.fnGetCodeList(options).then(list => {
        this.agentAuthorizationTypeArList = list.ar
        this.agentAuthorizationTypeEnList = list.en
      }).catch((res)=>{
        eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
      })

      this.fnGetAgentMembers()
    },
    fnGetAgentMembers(){
      requestApi({
        url: '/users/agent/offices/users',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.agentMembers = res.data.list
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetAgentMembers()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnDetail(item){
      if (item.ind_active === 'N') {
        return
      }
      this.seq = item.seq
      this.agentMemberAdd = false
      this.agentMemberDetail = true
    },

    fnMemberDeleteConfirm(item){
      if (item.ind_representative === 'Y') {
        let snackBarOptions = {
          text: this.$t('user.agent.members.fields.delete_fail_2')
        }
        eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
        return
      }

      if (item.application_cnt > 0) {
        let snackBarOptions = {
          text: this.$t('user.agent.members.fields.delete_fail_3')
        }
        eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
        return
      }


      let seq = item.seq
      let options = {
        title: this.$t('common.message.delete.confirm.title'),
        text: this.$t('common.message.delete.confirm.text'),
        yes: {
          text: this.$t('common.button.yes'),
          event: 'delete',
          callback: {
            seq: seq
          }
        },
        no: {
          text: this.$t('common.button.no')
        }
      }
      eventBus.$emit('SHOW_CONFIRM_DIALOG'+ this.id, options)
    },

    fnMemberDelete(obj){
      requestApi({
        url: '/users/agent/offices/users/'+obj.seq,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {

            if(res.data.ind_active == 'N'){
              let snackBarOptions = {
                text: this.$t('user.agent.members.fields.delete_fail_1')
              }
              eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
              eventBus.$emit('CLOSE_CONFIRM_DIALOG'+ this.id)
            }else{
              if(res.data.ind_representative == 'Y'){

                let snackBarOptions = {
                  text: this.$t('user.agent.members.fields.delete_fail_2')
                }
                eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)
                eventBus.$emit('CLOSE_CONFIRM_DIALOG'+ this.id)

              }else{
                requestApi({
                  url: '/users/agent/offices/users/'+obj.seq,
                  method: 'DELETE',
                  callback: (res) => {
                    if (res.res_code === '200') {
                      eventBus.$emit('CLOSE_CONFIRM_DIALOG'+ this.id)

                      let snackBarOptions = {
                        text: this.$t('common.message.delete.success')
                      }
                      eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

                      this.agentMemberAdd = false
                      this.agentMemberDetail = false
                      this.fnGetAgentMembers()
                    }else{
                      eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                    }
                  }
                })
              }
            }

          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnMemberDelete(obj)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnCloseDetail() {
      this.agentMemberDetail = false
      this.tab = ''
    },

    fnGetAgentAuthTypeDesc (code) {
      let list = this.$vuetify.rtl ? this.agentAuthorizationTypeArList : this.agentAuthorizationTypeEnList

      let agentAuthType = list.find(item => {
        return item.value === code
      })

      return (code) ? agentAuthType.text : ''
    },

    fnGetItemRowClass (item) {
      return item.ind_active === 'N' ? 'inactive': ''
    }
  }
}
</script>